<template>
  <v-container grid-list-xs fluid pa-0>
    <v-layout
      row
      wrap
      align-center
      justify-space-around
      class="secondary darken-1"
      style="min-height:140px"
    />

    <v-layout row wrap justify-center style="margin-top:-54px">
      <v-card class="flex xs12 sm11 shadow">
        <v-toolbar color="white" flat height="54px">
          <div class="di-flex align-center">
            <v-icon size="35px">mdi-account-multiple</v-icon>
            <span class="subheading font-weight-bold mt-2 ml-3">
              {{ $t("users") }}
            </span>
          </div>
          <v-spacer />
          <v-btn
            icon
            small
            color="secondary"
            class="shadow-md"
            v-if="can('add_users')"
            @click="dialog = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />

        <v-data-table :headers="headers" :items="items" :loading="loading">
          <template slot="items" slot-scope="{ item, index }">
            <td>{{ index + 1 }}</td>
            <td>
              <v-avatar size="32">
                <img :src="item.image" alt="alt" />
              </v-avatar>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>
              <v-btn
                icon
                flat
                small
                class="ma-0 pa-0"
                color="grey darken-2"
                @click="deleteItem(item)"
                v-if="can('delete_users')"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-layout>

    <v-dialog
      persistent
      v-model="dialog"
      :overlay="false"
      max-width="800px"
      class="pa-2 no-radius"
    >
      <v-card-title class="white py-2 primary white--text">
        <h4>{{ $t(form_title) }}</h4>
        <v-spacer />
        <v-btn dark flat icon small class="ma-0 pa-0" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form class="white pa-4 border no-radius">
        <v-text-field
          :label="$t('name')"
          data-vv-name="name"
          v-model="user.name"
          :data-vv-as="$t('name')"
          v-validate="'required'"
          @input="correct = true"
          :error-messages="errors.collect('name')"
        />
        <v-text-field
          type="email"
          :label="$t('email')"
          data-vv-name="email"
          v-model="user.email"
          @input="correct = true"
          :data-vv-as="$t('email')"
          v-validate="'required|email'"
          :error-messages="errors.collect('email')"
        />
        <v-text-field
          type="password"
          :label="$t('password')"
          v-validate="'required'"
          @input="correct = true"
          data-vv-name="password"
          v-model="user.password"
          :data-vv-as="$t('password')"
          :error-messages="errors.collect('password')"
        />
        <v-autocomplete
          chips
          multiple
          autocomplete
          return-object
          :items="roles"
          item-value="id"
          item-text="name"
          data-vv-name="role"
          :label="$t('role')"
          v-model="user.roles"
          :data-vv-as="$t('role')"
          v-validate="'required'"
          :error-messages="errors.collect('role')"
        />
        <v-layout row wrap justify-end px-0 mt-4>
          <v-btn
            class="mr-0"
            @click="save"
            color="btn_color secondary"
            :loading="loading"
            >{{ $t("save") }}
          </v-btn>
        </v-layout>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Users",
  data: () => ({
    items: [],
    roles: [],
    search: "",
    loading: true,
    dialog: false,
    user: {
      id: null,
      roles: null,
      name: null,
      email: null,
      profile: null,
      password: null
    },
    form_title: "new_user"
  }),

  computed: {
    ...mapGetters("AuthModule", { current_user: "current_user" }),

    headers: vm => [
      { text: vm.$t("number"), sortable: false, width: "150px" },
      { text: vm.$t("profile"), sortable: false, width: "50px" },
      { text: vm.$t("name"), value: "name" },
      { text: vm.$t("email"), value: "email" },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ]
  },
  methods: {
    getRoles() {
      this.axios.get("users/create").then(res => {
        this.roles = Object.values(res.data);
      });
    },

    initData() {
      this.loading = true;
      this.getRoles();
      this.axios.get("users").then(resp => {
        this.items = resp.data;
        this.loading = false;
      });
    },

    deleteItem(item) {
      let vm = this;
      this.$alert(`/users/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios.post("users", this.user).then(res => {
            this.loading = false;
            this.dialog = false;
            this.items.push(res.data);
          });
        }
      });
    }
  },

  created() {
    this.initData();
  }
};
</script>
